import React from 'react';

import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  ul: {
    marginLeft: 40,
  },
}));

function TermoCancelmento() {
  const classes = useStyles();

  return (
    <div>
      <p>Prezado cliente,</p>
      <p>
        <strong>A Xmei Brasil</strong>, no uso de suas atribuições como empresa
        contratada e competente para gerir suas obrigações fiscais mediante a
        assinatura do aplicativo,
        <strong>
          {' '}
          alerta que a empresa possui diversas obrigações fiscais
        </strong>
        junto ao Fisco.
      </p>
      <p>
        <strong>Vale ressaltar que essas obrigações fiscais</strong> estão
        relacionadas a entrega de obrigações acessórias bem como o próprio
        pagamento do tributo, sendo que estas obrigações
        <strong>
          {' '}
          serão apresentadas mesmo que a empresa não tenha movimento
        </strong>
        . Dentre elas, estão;
      </p>
      <ul className={classes.ul}>
        <li>DEFIS (Declaração de Informações Socioeconômicas e Fiscais);</li>
        <li>
          DASN-SIMEI (Declaração Anual do Simples Nacional – Microempreendedor
          Individual);
        </li>
        <li>DIRF (Declaração de Imposto de Renda Retido na Fonte);</li>
        <li>DCTF web (Declaração de Débitos Tributários Federais); </li>
        <li>REST; </li>
        <li>DMS;</li>
        <li>Licenciamento anual junto a prefeitura; </li>
        <li>Emissão de notas fiscais;</li>
        <li>Guias de tributos; </li>
        <li>Certidões negativas;</li>
        <li>Etc.</li>
      </ul>
      <p>
        Desta forma,
        <strong>
          {' '}
          a partir do momento do cancelamento ou suspensão da assinatura
        </strong>
        dos serviços
        <strong>
          a Xmei não terá mais responsabilidade de cumprir com qualquer uma das
          obrigações citadas
        </strong>
        , sendo importante destacar que
        <strong>
          {' '}
          a ausência destas obrigações incorrerá em penalidades (multas) por
          parte das autoridades fiscais (Receita Federal e Municipio).
        </strong>
      </p>
      <p>
        Caso não deseje continuar com assinatura cancelada ou suspensa pedimos
        por gentileza que entre em contato urgente com nosso departamento
        comercial para imediata regularização da sua assinatura, a fim de evitar
        pendencias tributárias e multas, conforme já citado.
      </p>
      <p>Atenciosamente,</p>
      <p>Xmei Brasil S.A</p>
    </div>
  );
}

export default TermoCancelmento;
